import { Box, Tooltip, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

function LeatherPicker({ pocket, effectiveColor, leatherColors, colorSelectionHandler }) {

    const [selectedColor, setSelectedColor] = React.useState(null)

    useEffect(() => {
        const c = leatherColors.find(color => color.id === effectiveColor);
        setSelectedColor(c);
    }, [effectiveColor, leatherColors]);

    return (
        <Box key={pocket.id} sx={{ mb: 3 }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>
                {pocket.name}
                {selectedColor && (
                    <span>: {selectedColor?.name}</span>
                )}
            </Typography>
            <Box sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 1,
                padding: 1
            }}>
                {leatherColors.map((color) => (
                    <Tooltip title={color.name} key={color.id}>
                        <Box
                            onClick={() => colorSelectionHandler(pocket.id, color.id)}
                            sx={{
                                width: 32,
                                height: 32,
                                borderRadius: '50%',
                                overflow: 'hidden',
                                cursor: 'pointer',
                                border: '2px solid',
                                filter: effectiveColor === color.id ? 'drop-shadow(0px 0px 4px #00F)' : null,
                                borderColor: effectiveColor === color.id ? 'primary.main' : 'divider',
                                backgroundImage: `url(${color.swatch})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                '&:hover': {
                                    transform: 'scale(1.1)',
                                },
                                transition: 'all 0.2s ease-in-out'
                            }}
                            data-testid= {`leather-${pocket.id}-${color.id}`}
                        />
                    </Tooltip>
                ))}
            </Box>
        </Box>
    )
}

LeatherPicker.propTypes = {
    pocket: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
    }).isRequired,
    effectiveColor: PropTypes.func.isRequired,
    leatherColors: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        swatch: PropTypes.string.isRequired,
    })).isRequired,
    colorSelectionHandler: PropTypes.func.isRequired,
}

export default LeatherPicker